import { Tooltip } from 'antd';

export default function ImageTooltipComp(props: any) {
    return (
        <Tooltip color='black' trigger='click|hover' title={props.text}>
            <img
                style={{
                    height: '30px',
                    maxWidth: '40px',
                    borderRadius: '5px',
                }}
                src={props.img}
                alt={props.text}
            />
        </Tooltip>
    );
}
